/**
 * Highlight Target Product - Resalta productos específicos en la colección cuando se accede con un hash en la URL
 */
(function() {
  class HighlightTargetProduct {
    constructor() {
      // Configuración por defecto
      this.config = {
        scrollThreshold: 50,    // px de scroll antes de restaurar opacidad
        dimOpacity: 0.5,        // opacidad para productos no resaltados
        transitionDuration: 0.3,  // duración de la transición en segundos
        scrollDelay: 800        // tiempo de espera antes de aplicar scroll (ms)
      };
      
      // Guardar el hash actual para detectar cambios manuales
      this.currentHash = window.location.hash;
      
      // Flag para controlar si el scroll fue iniciado por el script
      this.isScriptScroll = false;
      
      // Inicializar cuando el DOM esté completamente cargado
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        // Si el DOM ya está cargado, inicializar inmediatamente
        this.init();
      }
    }

    init() {
      const grid = document.getElementById('supplements-guide-grid');
      if (!grid) return;

      // Leer configuraciones del grid si están disponibles
      if (grid.dataset.scrollThreshold) {
        this.config.scrollThreshold = parseInt(grid.dataset.scrollThreshold, 10);
      }
      if (grid.dataset.dimOpacity) {
        this.config.dimOpacity = parseFloat(grid.dataset.dimOpacity);
      }
      if (grid.dataset.transitionDuration) {
        this.config.transitionDuration = parseFloat(grid.dataset.transitionDuration);
      }

      // Aplicar estilos CSS
      this.applyStyles();
      
      // Manejar hash inicial
      if (window.location.hash) {
        this.highlightTargetProduct();
      }
      
      // Eventos para manejar cambios de hash
      window.addEventListener('hashchange', () => this.handleHashChange());
      
      // Detectar cuando el usuario presiona Enter en la URL con el mismo hash
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && window.location.hash) {
          // Forzar la aplicación del efecto incluso si el hash no ha cambiado
          e.preventDefault(); // Prevenir la recarga de la página
          this.handleHashChange();
        }
      });
      
      // También detectar cuando se presiona Enter en la barra de direcciones
      window.addEventListener('popstate', () => {
        if (window.location.hash) {
          this.handleHashChange();
        }
      });
      
      // También manejar clicks en enlaces con hash
      document.addEventListener('click', (e) => {
        if (e.target.tagName === 'A' && e.target.hash && e.target.hash === window.location.hash) {
          e.preventDefault();
          this.handleHashChange();
        }
      });
    }
    
    handleHashChange() {
      // Actualizar el hash guardado
      this.currentHash = window.location.hash;
      
      // Restaurar opacidad normal antes de aplicar el nuevo resaltado
      this.restoreNormalOpacity();
      
      // Si hay un hash, aplicar resaltado
      if (window.location.hash) {
        // Forzar la aplicación del efecto incluso si estamos en la misma URL
        this.highlightTargetProduct();
      }
    }

    applyStyles() {
      const style = document.createElement('style');
      style.textContent = `
        .c-collection__item {
          transition: opacity ${this.config.transitionDuration}s ease-out;
        }
        .c-collection__item.dimmed {
          opacity: ${this.config.dimOpacity};
        }
      `;
      document.head.appendChild(style);
    }

    highlightTargetProduct() {
      const targetId = window.location.hash.substring(1);
      const items = document.querySelectorAll('.c-collection__item');
      
      // Si no hay hash o no hay elementos, no hacer nada
      if (!targetId || items.length === 0) return;
      
      // Primero restaurar cualquier opacidad anterior
      this.restoreNormalOpacity();
      
      let targetFound = false;
      let targetItem = null;
      
      // Aplicar las clases de opacidad
      items.forEach(item => {
        if (item.id === targetId) {
          targetFound = true;
          targetItem = item;
          // Asegurarse de que el elemento resaltado no tenga la clase dimmed
          item.classList.remove('dimmed');
        } else {
          item.classList.add('dimmed');
        }
      });
      
      // Si no se encontró el elemento objetivo, restaurar opacidad y salir
      if (!targetFound || !targetItem) {
        this.restoreNormalOpacity();
        return;
      }
      
      // Cancelar cualquier scroll listener existente
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
        this.scrollHandler = null;
      }
      
      // Marcar que el scroll es iniciado por el script
      this.isScriptScroll = true;
      
      // Función para comprobar si un elemento está en el viewport
      const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
      };
      
      // Comprobar si el elemento ya está en el viewport
      if (isElementInViewport(targetItem)) {
        // Si ya está en el viewport, configurar el listener de scroll inmediatamente
        setTimeout(() => {
          this.setupScrollListener();
          setTimeout(() => { this.isScriptScroll = false; }, 500);
        }, 100);
      } else {
        // Si no está en el viewport, hacer scroll al elemento
        targetItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        // Esperar a que termine el scroll antes de configurar el listener
        setTimeout(() => {
          this.setupScrollListener();
          setTimeout(() => { this.isScriptScroll = false; }, 1000);
        }, this.config.scrollDelay);
      }
    }

    setupScrollListener() {
      // Eliminar listener anterior si existe
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
        this.scrollHandler = null;
      }
      
      // Obtener el elemento objetivo
      const targetId = window.location.hash.substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (!targetElement) return;
      
      // Guardar la posición inicial del scroll cuando el elemento está en el viewport
      let initialScrollY = null;
      
      // Función para comprobar si un elemento está en el viewport
      const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
      };
      
      // Crear el handler de scroll
      this.scrollHandler = () => {
        // Si el scroll fue iniciado por el script, ignorarlo
        if (this.isScriptScroll) {
          return;
        }
        
        // Si aún no tenemos la posición inicial y el elemento está en el viewport,
        // guardar la posición actual como posición inicial
        if (initialScrollY === null && isElementInViewport(targetElement)) {
          initialScrollY = window.scrollY || window.pageYOffset;
          return;
        }
        
        // Si ya tenemos la posición inicial, comprobar si el usuario ha hecho scroll
        // más allá del umbral desde esa posición
        if (initialScrollY !== null) {
          const currentScrollY = window.scrollY || window.pageYOffset;
          const scrollDifference = Math.abs(currentScrollY - initialScrollY);
          
          if (scrollDifference > this.config.scrollThreshold) {
            this.restoreNormalOpacity();
            window.removeEventListener('scroll', this.scrollHandler);
            this.scrollHandler = null;
          }
        }
      };
      
      // Añadir el listener de scroll
      window.addEventListener('scroll', this.scrollHandler);
    }

    restoreNormalOpacity() {
      document.querySelectorAll('.c-collection__item.dimmed').forEach(item => {
        item.classList.remove('dimmed');
      });
    }
  }

  // Crear una única instancia cuando se carga el script
  const highlighter = new HighlightTargetProduct();
})();
